(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalDateTimeFilter', [RfGlobalDateTimeFilterFn]);

    // date-time filter (day, month, year, hour, minute, second), uses moment.locale (set on login)
    function RfGlobalDateTimeFilterFn() {
        return function (date) {
            if (date) {
                var dateMoment = moment(date);
                return dateMoment.format('L') + ' ' + dateMoment.format('LTS');
            }
            return date;
        };
    }
})();